/**
 * @flow
 */

import React, { Component } from 'react'

import {
  OrganizationContainer,
  Image,
  ImageContainer,
  ContentContainer,
  ContentTitle,
  ContentDescription
} from './styledComponents'

type Props = {
  imageUrl: string,
  title: string,
  content: string
}

class OrganizationSection extends Component<Props> {
  render() {
    const { imageUrl, title, content } = this.props

    return (
      <OrganizationContainer>
        <ImageContainer>
          <Image dataSrc={imageUrl} alt={title} className="lazyload" />
        </ImageContainer>
        <ContentContainer>
          <ContentTitle as="article">{title}</ContentTitle>
          <ContentDescription as="article">{content}</ContentDescription>
        </ContentContainer>
      </OrganizationContainer>
    )
  }
}

export default OrganizationSection



// WEBPACK FOOTER //
// ./src/components/TeamNew/ApplicationSection/OrganizationSection/index.js